<div class="toast-container">
  <div
    *ngFor="let toast of toastsSignal(); trackBy: trackById"
    [ngClass]="[
      'toast',
      'toast--' + toast.type,
      isExpanded(toast.id) ? 'toast--expanded' : ''
    ]"
    (mouseenter)="onToastMouseEnter(toast.id)"
    (mouseleave)="onToastMouseLeave(toast.id)"
  >
    <div class="toast__content">
      <mat-icon class="toast__icon">{{ getIcon(toast.type) }}</mat-icon>

      <div class="toast__text">
        <div class="toast__title">{{ toast.title }}</div>
        <div
          class="toast__description"
          [ngClass]="{ 'toast__description--collapsed': !isExpanded(toast.id) && isLongDescription(toast.id) }"
        >
          <span *ngIf="toast.htmlContent; else plainText" [innerHTML]="toast.description"></span>
          <ng-template #plainText>{{ toast.description }}</ng-template>
        </div>

        <button *ngIf="isLongDescription(toast.id)" class="toast__expand-btn" (click)="toggleExpand(toast.id)">
          {{ isExpanded(toast.id) ? ('COM.TOAST.SHOW_LESS' | translate) : ('COM.TOAST.SHOW_MORE' | translate) }}
        </button>
      </div>
    </div>

    <button mat-icon-button class="toast__close-btn" (click)="removeToast(toast.id)" [attr.aria-label]="'COM.TOAST.CLOSE_TOAST' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>